module.exports = __webpack_public_path__ + "static/media/twitter.f04247f8.svg";